/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I find the best value fantasy picks here?`)
};

const es_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo encuentro aquí los mejores picks de valor para fantasy?`)
};

const de_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie finde ich hier die besten Value-Picks für Fantasy?`)
};

const nl_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe vind ik hier de beste value-picks voor fantasy?`)
};

const fr_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment trouver ici les meilleurs picks fantasy à valeur sûre ?`)
};

const it_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come trovo qui le migliori scelte di valore per il fantasy?`)
};

const pt_br2_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro aqui as melhores escolhas de valor para o fantasy?`)
};

const pt_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro aqui as melhores escolhas de valor para o fantasy?`)
};

const ja_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここで最もお得なファンタジーピックを見つけるにはどうすればよいですか？`)
};

const zh_f1_stx_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我该如何在这里找到最具性价比的梦幻选择？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stx_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stx_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stx_faq2_q", locale)
	if (locale === "en") return en_f1_stx_faq2_q(inputs)
	if (locale === "es") return es_f1_stx_faq2_q(inputs)
	if (locale === "de") return de_f1_stx_faq2_q(inputs)
	if (locale === "nl") return nl_f1_stx_faq2_q(inputs)
	if (locale === "fr") return fr_f1_stx_faq2_q(inputs)
	if (locale === "it") return it_f1_stx_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stx_faq2_q(inputs)
	if (locale === "pt") return pt_f1_stx_faq2_q(inputs)
	if (locale === "ja") return ja_f1_stx_faq2_q(inputs)
	return zh_f1_stx_faq2_q(inputs)
};